import QuizCreation from '@/shared-components/forms/add-board-content/board-text-body/add-element/add-quiz/QuizCreation';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

export default function QuizManager({
  isQuizModalOpen,
  setIsQuizModalOpen,
  quizToEdit,
  setQuizToEdit,
  dispatch,
}) {
  const handleClose = () => {
    setIsQuizModalOpen(false);
    setQuizToEdit(null);
  };

  const handleDelete = () => {
    if (!quizToEdit) return;
    dispatch({ type: 'BLOCK_REMOVED', blockType: 'post_quizzes', id: quizToEdit.quizId });
    handleClose();
  };

  const handleQuizSubmit = (data) => {
    dispatch({
      type: 'BLOCK_CREATED',
      blockType: 'post_quizzes',
      data: {
        question: data.question,
        options: data.options,
        correctOption: data.correctOption,
      },
    });
    setIsQuizModalOpen(false);
  };

  const handleQuizUpdate = (updated) => {
    if (!quizToEdit) return;
    dispatch({ type: 'QUIZ_UPDATED', id: quizToEdit.quizId, changes: updated });

    setQuizToEdit(null);
    setIsQuizModalOpen(false);
  };

  return (
    <>
      {isQuizModalOpen && (
        <GenericPopup
          className="poll-quiz-creation-popup remove-scrollbar"
          open={isQuizModalOpen}
          opacity
          onBackgroundClick={handleClose}
        >
          <QuizCreation
            key={quizToEdit ? `quiz-edit-${quizToEdit.id}` : 'quiz-new'}
            initialQuizData={quizToEdit}
            onSubmit={quizToEdit ? handleQuizUpdate : handleQuizSubmit}
            onClose={handleClose}
            onDelete={quizToEdit ? handleDelete : undefined}
          />
        </GenericPopup>
      )}
    </>
  );
}
